<template>
  <div>
    <div v-if="loading" class="text-center" style="min-height:200px">
        <b-spinner></b-spinner>
    </div>
    <div v-else>
        <b-card>
            <b-list-group-item class="d-flex align-items-center m-0 p-0 border-0">
            <b-avatar :badge="(customerDetails.aqStatus).toString()" :badge-variant="customerDetails.status === 1 ? 'success': 'danger'" variant="info" :src="customerDetails.profilePicture"></b-avatar>
            <span class="mr-auto ml-2 text-uppercase"><strong>{{customerDetails.fName}} {{customerDetails.lName}}</strong></span>
            <b-badge variant="success">
                {{checkFlagStatus(customerDetails.flag).funnel}} {{checkFlagStatus(customerDetails.flag).state}}
            </b-badge>
            </b-list-group-item>
            <b-row class="m-0 py-2">
                <b-col cols="8">
                    DL: <strong>{{customerDetails.DLnumber || 'Not Available'}}</strong>
                </b-col>
                <b-col class="text-right">
                    Penalty: <strong>{{customerDetails.penaltyCharge}}</strong>
                </b-col>
            </b-row>
            <div class="col-md-12 d-flex">
                <p class="mr-2">Active Status:  </p>
                <p
                    v-bind:style="{
                    color: checkActiveStatus(customerDetails.activeStatus).color,
                    }"
                >{{checkActiveStatus(customerDetails.activeStatus).description}}
                <b-badge
                v-b-tooltip:hover
                title="Active Status lets you know how active the customer is, higher active status denotes less active."
                :variant="customerDetails.activeStatus > 2 ? 'danger' : 'success'"
                >{{customerDetails.activeStatus}}</b-badge>
                </p>
            </div>
        </b-card>
        <div class="my-4 p-2">
            <p class="m-0 p-0"><strong>Email: </strong>
                {{customerDetails.email}}
            </p>
            <p class="m-0 p-0"><strong>Mobile: </strong>
                {{customerDetails.mobile}}, {{customerDetails.alternateNo || 'No alternate number provided.'}}
            </p>
        </div>
        <div class="my-4 text-right">
            <b-button variant="outline-primary" @click="$router.push('/userProfile/' + customerDetails.id + '/' + customerDetails.mobile)">View Full Details</b-button>
        </div>
    </div>
  </div>
</template>

<script>
const axios = require("axios");
import responsivenessData from "../../Inventory/responsiveness";
import flags from "../../Inventory/flags.json";

export default {
    data() {
        return {
             customerDetails: null,
             loading: false,
             responsivenessData: responsivenessData,
             flags: flags
        }
    },
    props: {
        id: Number
    },
    methods: {
        checkActiveStatus(status) {
        var x = this.responsivenessData.find((x) => {
            return x.activeStatus == status;
        });
        return x
        ? x
        : { activeStatus: status, color: "red", description: "Not Defined" };
        },
        checkFlagStatus(status) {
        return this.flags.find((x) => {
            return x.flag == status;
        });
    },
    },
    async created() {
        try {
            this.loading = true
            const {data} = await axios.get("https://api.on-track.in/api/customer/"+ this.id,
            {
                headers: {
                "Content-Type": "application/json",
                Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
                },
            })
            console.log(data)
            this.customerDetails = data
        } finally {
            this.loading = false
        }
    }
}
</script>

<style>

</style>